import React, { useEffect, useState } from "react";

//MUI
import {
  Box,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

import { API } from "../../config";
import { fnExcel, fni18n } from "../../services/commonService";
import { getAPI } from "../../services/commonService";
import AuthenticationService from "../auth/AuthenticationService";

import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import USelectBox from "../../components/mui/USelectBox";
import UTextField from "../../components/mui/UTextField";
import UButton from "../../components/mui/UButton";
import UDatePickers from "../../components/mui/UDatePickers";
import UTable from "../../components/mui/UTable";
import UPopupForm from "../../components/mui/UPopupForm";
import PmsLogPopUpPage from "./PmsLogPopUpPage";
const useYn = [
    {cd: "1", name: "Success"},
    {cd: "-1", name: "Failed"},
];
export default function HistPage() {
  const userLoginId = AuthenticationService.getLoggedInUserID();
  const [branchs, setBranch] = useState([]);
  const [transType, setTransType] = useState([]);
  const [depWitd, setDepWitd] = useState([]);
  const [userGroups, setUserGroups] = useState([]);
  const now = new Date().toISOString().slice(0, 10);
  const [formOpen, setFormOpen] = useState(false); // modify dialog
  const [search, setSearch] = useState({
    startDate: now,
    endDate: now,
    // pageNum: "1",
    // machId: "",
    // transType: "",
    // trnsctSeq: "",
    // userId: "",
    // storeCd: "N/A",
    // brandCd: "N/A",
    // result:'ALL',
  });
  const [rows, setRows] = useState([]); //지점
  const [machineList, setMachineList] = useState([]);
  const [retailers, setRetailers] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [brands, setBrands] = useState([]);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  //화면 로드 시
  useEffect(() => {
    const getLoadData = async () => {
      try {
        await Promise.all([
            loadComboBoxBranchGroup(),
            loadComboBoxBranch(),
            loadComboBoxTransType()
        ]);
      } catch (e) {
        console.error('초기 로딩 실패:', e.message);
      }
    };
    getLoadData();
  }, []);

  useEffect(() => {
    if (!isFirstLoad) return;
    if (search.storeCd) {
      loadDataGrid(); 
      setIsFirstLoad(false);
    }
  }, [search]);

  const columns = [
    {
      field: "recvDate",
      headerName: "일자",
      width: 120,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "storeCd",
      headerName: "지점",
      width: 100,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "termId",
      headerName: "기기번호",
      width: 100,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "machineSeq",
      headerName: "기기일련번호",
      width: 100,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "acntCd",
      headerName: "거래코드",
      width: 100,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "gwSeq",
      headerName: "GW일련번호",
      width: 100,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "machineIp",
      headerName: "정산기기IP",
      width: 100,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "machineNum",
      headerName: "기기제조번호",
      width: 100,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "result",
      headerName: "PMS결과",
      width: 100,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "pendedYn",
      headerName: "지연전송",
      width: 50,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "payload",
      headerName: "전문",
      width: 120,
      editable: false,
      align: "left",
      headerAlign: "left",
      hide: true,
    },
    {
      field: "detail",
      headerName: "상세",
      width: 70,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <UButton
          onButtonClick={() => onSelectedRows(params.rows)}
          variant="outlined"
        >
          보기
        </UButton>
      ),
    },
  ];
  const clearSearchVal = ()=>{
    setSearch({
      ...search,
      ['storeCd']: 'N/A',
    });
    setMachineList([]);
    setBrands([]);
  }

  // 콤보박스 데이터
  const loadComboBoxBranchGroup = async () => {
    try {
      const res = await getAPI(API.COMMON.BRANCH_GROUP, {userId: userLoginId,branchGroupTy: "BIZ_TY",useYn:"Y"});
      const _inputData = res.data.result.map((m) => ({
          cd: m.id,
          name: m.branchGroupNm,
      }));
      setRetailers(_inputData);
      // await loadComboBoxBranch(_inputData[0].cd);
    } catch (e) {
      console.error(e.message);
    }
  };

  // 콤보박스 데이터
  const loadComboBoxBranch = async (param) => {
    try {
      const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId, bizTy:param, });
      const _inputData = res.data.result.map((m) => ({
        cd: m.storeCd,
        name: m.storeNm,
      }));
      // setSearch({
      //     ...search,
      //     ['storeCd'] : _inputData[0].cd,
      // })
      setBranch(_inputData);
      if (_inputData.length > 0) {
        await getMachineList(_inputData[0].cd);
        await loadComboBoxBrand(_inputData[0].cd);
      } else {
        clearSearchVal()
      }
    } catch (e) {
      console.error(e.message);
    }
  };
  // 기번 가져오기
  const getMachineList = async (param) => {
    try {
      let res = await getAPI(API.COMMON.MACHINE + param);
      let data = res.data.result.map((m) => ({
        cd: m.machId,
        name: m.machId,
      }));
      setMachineList(data);
    } catch (e) {
      console.log("[TotalPage.jsx] getMachineList() Exception => " + e.message);
    }
  };

  const loadComboBoxTransType = async () => {
    try {
      const res = await getAPI(API.COMMON.TRANS_TYPE);
      const _inputData = res.data.result.map((m) => ({
        cd: m.cd,
        name: m.cdNm,
      }));
      setTransType(_inputData);
    } catch (e) {
      console.error(e.message);
    }
  };
  const loadComboBoxDepWitd = async () => {
    try {
      const res = await getAPI(API.COMMON.IN_OUT);
      const _inputData = res.data.result.map((m) => ({
        cd: m.cd,
        name: m.cdNm,
      }));
      setDepWitd(_inputData);
    } catch (e) {
      console.error(e.message);
    }
  };
  const loadComboBoxUserGroup = async () => {
    try {
      const res = await getAPI(API.COMMON.USER_GROUP);
      const _inputData = res.data.result.map((m) => ({
        cd: m.grpCd,
        name: m.grpNm,
      }));
      setUserGroups(_inputData);
    } catch (e) {
      console.error(e.message);
    }
  };
  const loadComboBoxBrand = async (branch) => {
    try {
      const res = await getAPI(API.COMMON.BRAND, {
        userId: userLoginId,
        branch: branch,
      });
      const _inputData = res.data.result.map((m) => ({
        cd: m.brandCd,
        name: m.brandNm,
      }));
      if (_inputData.length > 0) {
        setSearch({
          ...search,
          ["brandCd"]: _inputData[0].cd,
          ["storeCd"]: branch,
        });
      } else {
        setSearch({
          ...search,
          ["brandCd"]: "N/A",
          ["storeCd"]: branch,
        });
      }
      setBrands(_inputData);
    } catch (e) {
      console.error(e.message);
    }
  };
  //콤보박스 아이템 선택
  const onChangeCombo = (e) => {
    const { name, value } = e.target;
    setSearch({
      ...search,
      [name]: value === "ALL" ? "" : value,
    });
    if (name === "bizTy") {
      loadComboBoxBranch(value);
    }
    if (name === "storeCd") {
      getMachineList(value);
      loadComboBoxBrand(value);
    }
  };

  //데이터그리드
  const loadDataGrid = () => {
    getAPI(API.SYSTEM.PMS_LOG, search).then((res) => {
      setRows(res.data.result);
    });
  };

  const onSelectedRows = (row) => {
    setSelectedRow(row);
    setFormOpen(true);
  };

  function onButtonClick(dvsn, params) {
    if (dvsn === "초기화") {
    } else if (dvsn === "조회") {
      loadDataGrid(search);
    } else if (dvsn === "journal") {
      setSelectedRow(params.rows);
      setFormOpen(true);
    }
  }

  const onSearchChange = (e) => {
    let { name, value } = e.target;
    setSearch({
      ...search,
      [name]: value === "ALL" ? "" : value,
    });
  };

  //폼 팝업
  const handleFormOpen = () => {
    setFormOpen(true);
  };
  const handleFormClose = () => {
    setFormOpen(false);
  };

  return (
    <div className="main-container">
      <Box className="header">
        <Grid container>
          <Grid item xs={10}>
            {/* 상단메뉴명 */}
            <UBreadCrumbs title={"시스템관리"} subtitle={"기기전송로그"} />
          </Grid>
          <Grid item xs={2}>
            {/* 툴바 버튼 */}
            <Stack
              direction="row"
              justifyContent="flex-end"
              alignItems="flex-start"
              spacing={4}
            ></Stack>
          </Grid>
        </Grid>
      </Box>

      {/* 검색부 */}
      <Box className="contents">
        <TableContainer className="table-container">
          <Table className="table" size="small">
            <TableBody>
              <TableRow className="table-row-header">
                <TableCell className="table-cell-title">{fni18n("고객사")}</TableCell>
                <TableCell className="table-cell">
                    <USelectBox
                        name="bizTy"
                        items={retailers}
                        onItemChange={onChangeCombo}
                    />
                </TableCell>
                <TableCell className="table-cell-title">{fni18n("지점")}</TableCell>
                <TableCell className="table-cell">
                  {/* 점번선택 */}
                  <USelectBox
                    id="storeCd"
                    name="storeCd"
                    items={branchs}
                    onItemChange={onChangeCombo}
                    defaultValue={search.storeCd}
                  />
                </TableCell>

                <TableCell className="table-cell-title">{fni18n("기기번호")}</TableCell>
                <TableCell className="table-cell">
                  {/* 기번선택 */}
                  <USelectBox
                    id="machId"
                    name="machId"
                    items={machineList}
                    onItemChange={onChangeCombo}
                  />
                </TableCell>
                <TableCell className="table-cell-title">{fni18n("일자")}</TableCell>
                <TableCell colSpan={3} className="table-cell">
                  {/* 날짜선택 */}
                  <UDatePickers onChange={onSearchChange} />
                </TableCell>
              </TableRow>
              <TableRow className="table-row-header">
                <TableCell className="table-cell-title">{fni18n("브랜드번호")}</TableCell>
                <TableCell className="table-cell">
                  <UTextField
                    id="storeCd"
                    name="storeCd"
                    onChange={onChangeCombo}
                  />
                </TableCell>
                <TableCell className="table-cell-title">{fni18n("기기일련번호")}</TableCell>
                <TableCell className="table-cell">
                  {/* 거래번호 */}
                  <UTextField
                    id="transNo"
                    name="trnsctSeq"
                    onChange={onChangeCombo}
                  />
                </TableCell>
                <TableCell className="table-cell-title">{fni18n("거래코드")}</TableCell>
                <TableCell className="table-cell">
                  {/* 거래번호 */}
                  <UTextField
                    id="acntCd"
                    name="acntCd"
                    onChange={onChangeCombo}
                  />
                </TableCell>

                <TableCell className="table-cell-title">{fni18n("결과")}</TableCell>
                <TableCell className="table-cell"colSpan={3}>
                  <USelectBox
                    name="result"
                    items={useYn}
                    onItemChange={onSearchChange}
                    defaultValue={search.useYn}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <div className="search">
          <UButton icon="Search" onButtonClick={onButtonClick}>
            조회
          </UButton>
        </div>

        {/* 조회 리스트 */}
        <UTable
          tablabel={"거래1"}
          columns={columns}
          rows={rows}
          rowPerPage={10}
          // maxWidth={1600}
          // onSelectedRowChange={onSelectedRows}
        />
      </Box>

      {/* 팝업 */}
      <UPopupForm
        title={"로그상세"}
        open={formOpen}
        onClose={handleFormClose}
        content={<PmsLogPopUpPage data={selectedRow} />}
        type={"1"}
      />
    </div>
  );
}
